import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { EASE, Eyebrow } from "./motion";

export default function ComingSoon() {
  const { pathname } = useLocation();
  const name =
    pathname.replace(/\//g, " ").replace(/-/g, " ").trim() || "this page";

  return (
    <main className="flex min-h-[72vh] items-center justify-center bg-white px-6 pt-[72px]">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="max-w-lg text-center"
      >
        <div className="flex justify-center">
          <Eyebrow>In the works</Eyebrow>
        </div>
        <h1
          data-testid="coming-soon-title"
          className="mt-5 text-4xl font-extrabold capitalize tracking-tight text-slate-900"
        >
          {name}
        </h1>
        <p className="mt-4 text-[15px] leading-relaxed text-slate-600">
          This page is being crafted with the same care as everything else we build.
          It will be live soon.
        </p>
        <Link
          to="/"
          data-testid="coming-soon-home-link"
          className="group mt-8 inline-flex items-center gap-2 rounded-[10px] bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-blue-600"
        >
          <ArrowLeft size={15} className="transition-transform duration-300 group-hover:-translate-x-0.5" />
          Back to homepage
        </Link>
      </motion.div>
    </main>
  );
}
